/**
 * Authentication Service — IoC entry point.
 *
 * Business logic should import only from this file.
 * The concrete auth provider is injected into the service factory.
 */

import { clearAllTokens } from './tokenStore';
import { authProvider } from './provider';

export const createAuthService = (provider) => ({
    getSignInRedirectUrl: () => provider.getSignInRedirectUrl(),

    exchangeAuthorizationCode: ({ code }) =>
        provider.exchangeAuthorizationCode({ code }),

    refreshSession: () => provider.refreshSession(),

    logout: () => provider.logout(),

    clearTokens: () => clearAllTokens(),
});

export const authService = createAuthService(authProvider);